import { render } from "./SummaryAdvisorySection.vue?vue&type=template&id=044e99b6"
import script from "./SummaryAdvisorySection.vue?vue&type=script&lang=js"
export * from "./SummaryAdvisorySection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__